<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxSourceCell from "../../../../../../_shared/_modules/inbox-source-cell"
  import type { AssignRequesterCustomerDraft, AssignRequesterCustomerRow } from "../../contract"

  let { row }: InboxWorkflowCellProps<AssignRequesterCustomerRow, AssignRequesterCustomerDraft> =
    $props()
</script>

<InboxSourceCell label={row.sourceLabel} subLabel={row.sourceSubLabel} disabled={row.disabled} />
